import React from 'react';
import { browserHistory } from 'react-router';
import ConfirmActionModal from './ConfirmActionModal';
import * as PathConstants from '../../constants/pathConstants';

class ManualRefreshDetection extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showConfirmation: false };
    this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCloseConfirmation = this.handleCloseConfirmation.bind(this);
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleBeforeUnload() {
    const navEntries = performance.getEntriesByType('navigation');
    if (navEntries.length > 0 && navEntries[0].type === 'reload') {
      history.push(PathConstants.pathToHome);
      // Disable pop up as this will be blocked by browser.
      // const confirmationMessage = 'Refreshing here will take you to the home page. Are you sure you want to proceed?';
      // if (window.confirm(confirmationMessage)) {
      //   // User confirmed, redirect to the home page
        
      // } else {
      //   e.preventDefault();
      //   e.returnValue = '';
      // }
      // this.setState({ showConfirmation: true });
      // e.preventDefault();
      // e.returnValue = '';
    }
  }

  handleConfirm() {
    browserHistory.push(PathConstants.pathToHome);
  }

  handleCloseConfirmation() {
    this.setState({ showConfirmation: false });
  }

  render() {
    return (
      <div>
        <ConfirmActionModal
          modalShown={this.state.showConfirmation}
          onHide={this.handleCloseConfirmation}
          onConfirm={this.handleConfirm}
          confirmTitle="Confirm Refresh"
          confirmText="Refreshing here will take you to the home page. Are you sure you want to proceed?"
          confirmButtonText="Refresh"
          cancelButtonText="Cancel"
        />
      </div>
    );
  }
}

export default ManualRefreshDetection;



/** WEBPACK FOOTER **
 ** ./src/components/common/ManualRefreshDetection.js
 **/